import { getBackVersion } from '../config';
import { CustomerSnapshot } from '../models';
import api from './api';

type SaveCustomerArgs = {
    document: string;
    name: string;
    email: string;
    phone: string;
};

const get = (): Promise<CustomerSnapshot[]> =>
    api.request<CustomerSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/customers`,
    });

const save = ({
    name,
    email,
    document,
    phone,
}: SaveCustomerArgs): Promise<CustomerSnapshot> =>
    api.request<CustomerSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/customers`,
        data: {
            name,
            email,
            document,
            phone,
        },
    });

export default {
    get,
    save,
};
export type { SaveCustomerArgs };
